<template>
  <div :class="componentClassName">
    <a-page-heading>連絡先</a-page-heading>

    <m-section>
      <m-action-card title="連絡先情報" icon="list">
        <!--
        <template #action>
          <a-frequently-used-contact-button
            :active="isFrequentlyUsedContact"
            @click="handleFrequentlyContactClick"
            @change="handleFrequentlyContactChange"
          />
        </template>
        -->
        <a-summary-item-header class="t-phone-book-detail__caller-information" text="着信元情報">
          <div class="t-phone-book-detail__caller-information-control">
            <a-button
              v-if="canEdit"
              id="editButton"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="edit"
              label="編集"
              @click="handleEditCallerInformation"
            />
            <a-button
              v-if="canDelete"
              id="deleteButton"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="trash"
              label="削除"
              @click="handleRowContactRemove"
            />
          </div>
        </a-summary-item-header>
        <!--
        <m-data-list
          variant="long"
          :data="callerInformationData"
          class="t-phone-book-detail__caller-information-data"
          align-right
        />
        <m-data-list
          variant="long"
          :data="contactData"
          class="t-phone-book-detail__caller-information-data"
          align-right
          v-on:click="handleCallNumberClick"
        />
        -->

        <table
          class="m-data-list m-data-list--long m-data-list--align-right t-phone-book-detail__caller-information-data"
        >
          <template v-for="value in contactData" :key="value.label">
            <template v-if="value.label === '電話番号'">
              <tr class="m-data-list__row" @click="handleCallNumberClick">
                <td class="m-data-list__col m-data-list__col--label">{{ value.label }}</td>
                <td class="m-data-list__col m-data-list__col--value">
                  <div :id="value.id" class="m-data-list__value">{{ value.content }}</div>
                </td>
              </tr>
            </template>

            <template v-else-if="value.label === 'メモ'">
              <tr class="m-data-list__row">
                <td
                  class="m-data-list__col m-data-list__col--label m-data-list__col--vertical-align-top m-data-list__col--paragraph"
                >
                  {{ value.label }}
                </td>
                <td
                  :id="value.id"
                  class="m-data-list__col m-data-list__col--value m-data-list__col--vertical-align-top m-data-list__col--paragraph"
                >
                  <div class="m-data-list__value">{{ value.content }}</div>
                </td>
              </tr>
            </template>

            <template v-else>
              <tr class="m-data-list__row">
                <td class="m-data-list__col m-data-list__col--label">{{ value.label }}</td>
                <td class="m-data-list__col m-data-list__col--value">
                  <div :id="value.id" class="m-data-list__value">{{ value.content }}</div>
                </td>
              </tr>
            </template>
          </template>
        </table>

        <!--
        <a-summary-item-header class="t-phone-book-detail__call-history" text="発着信履歴">
          <div class="t-phone-book-detail__call-history-control">
            <a-button
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              label="もっと見る"
              @click="handleViewMore"
            />
          </div>
        </a-summary-item-header>

        <ul class="t-phone-book-detail__call-history-list">
          <li v-for="(item, key) in callHistoryData" :key="key" class="t-phone-book-detail__call-history-item">
            <span>
              <a-icon :icon="callStatus(item.status)" />
              {{ item.caller }}
            </span>
            <span>{{ item.time }}</span>
          </li>
        </ul>
        -->
        <m-form-action-buttons class="t-phone-book-detail__action-button">
          <a-button id="cancelButton" variant="outlined" color="primary" @click="handleCancel">キャンセル</a-button>
        </m-form-action-buttons>
      </m-action-card>
      <!--
      <div class="t-phone-book-detail__footer">
        <a-button
          :inline="true"
          variant="round"
          color="primary"
          size="medium"
          icon="phone-outgoing-call"
          label="発信"
          class="t-phone-book-detail__button-outgoing"
          @click="handleOutgoing"
        />
      </div>
      -->
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="phoneBookAddDetail_removeModal"
      v-model:visible="removeContactDialogVisible"
      class="o-modal-remove-contact-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveContact"
    >
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removeContactConfirmationMessageText" id="removeContactNo-text"/>
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="removeContactNo"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveContact"
        />
        <a-button
          id="removeContactYes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveContact"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="phoneBookDetail_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="dialogOkButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import AIcon from '@/components/atoms/icon';
import MActionCard from '@/components/molecules/action-card';
import ASummaryItemHeader from '@/components/atoms/summary-item-header';
import AButton from '@/components/atoms/button';
import MSection from '@/components/molecules/section';
import MDataList from '@/components/molecules/data-list';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AFrequentlyUsedContactButton from '@/components/atoms/frequently-used-contact-button';
import OModal from '@/components/organisms/modal';
import AText from '@/components/atoms/text';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';

import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';

export default {
  name: 't-phone-book-detail',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    ASummaryItemHeader,
    AButton,
    MFormActionButtons,
    OModal,
    AText,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // List
    callerInformationData: {
      type: Array,
      default: new Array(0),
    },
    callHistoryData: {
      type: Array,
      default: new Array(0),
    },
    isFrequentlyUsedContact: {
      type: Boolean,
      default: false,
    },
    // removeContactConfirmationMessageText: {
    //   type: String,
    //   default: null,
    // },
    handleFrequentlyContactClick: {
      type: Function,
      default: () => {},
    },
    handleFrequentlyContactChange: {
      type: Function,
      default: () => {},
    },
    // handleEditCallerInformation: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleDeleteCallerInformation: {
    //   type: Function,
    //   default: () => {},
    // },
    handleViewMore: {
      type: Function,
      default: () => {},
    },
    // handleCancel: {
    //   type: Function,
    //   default: () => {},
    // },
    handleOutgoing: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      removeContactDialogVisible: false,
      removeContactConfirmationMessageText: '',
      contactData: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      routingAfterCloseModalFlag: false,
      authInfo: this.$store.state.user.authInfo,
      POINT,
      selectedCompanyID: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-phone-book-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
    canEdit() {
      // 管理者権限(マスタ含)の場合は編集ボタンを表示
      return (
        PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo] ||
        (this.companyID !== POINT && this.authInfo === 'operator')
      );
    },
    canDelete() {
      // 管理者権限(マスタ含)の場合は削除ボタンを表示
      return (
        PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo] ||
        (this.companyID !== POINT && this.authInfo === 'operator')
      );
    },
  },
  mounted() {
    // 003300かつSOオペレータの場合は画面非表示
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else {
      this.selectedCompanyID = this.companyID;
    }

    if (this.companyID === POINT && !PERMISSIONS_FRONTEND['phoneDetailReading'][this.authInfo]) {
      this.$router.push({ path: '/permission-denied' });
    } else {
      const contactID = this.$route.query.contactID;
      if (contactID) {
        this.fetchContactDataHandler(contactID);
      }
    }
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      // 連絡先削除後の場合は、画面遷移
      if (this.routingAfterCloseModalFlag) {
        this.$router.push({
          path: '/contactlist',
          query: { wordFlag: this.$route.query.wordFlag, searchFormType: this.$route.query.searchFormType },
        });
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    callStatus(status) {
      let icon = '';
      switch (status) {
        case 'income':
          icon = 'phone-incoming-call-outline';
          break;
        case 'miss':
          icon = 'phone-missed-call-outline';
          break;
        case 'outcome':
          icon = 'phone-outgoing-call-outline';
          break;
        default:
          break;
      }
      return icon;
    },
    handleRowContactRemove(role, data) {
      this.removeContactDialogVisible = true;
      this.removeContactConfirmationMessageText = messageContent.confirmPhoneBookEntryDelete();
    },
    handleConfirmRemoveContact() {
      this.handleDeleteCallerInformation(this.$route.query.contactID);
      this.resetContactToRemove();
    },
    handleCancelRemoveContact() {
      this.resetContactToRemove();
    },
    resetContactToRemove() {
      this.removeContactDialogVisible = false;
      this.removeContactConfirmationMessageText = '';
    },
    fetchContactDataHandler: async function (contactID) {
      await this.postRequest('/contactlist/getcontactdata', { contactID: contactID, companyID: this.selectedCompanyID })
        .then(e => {
          if (e.session) {
            this.contactData = [
              {
                label: '名前',
                content: e.data.view_name,
                id: 'name',
              },
              {
                label: 'フリガナ（名前）',
                content: e.data.view_nameKana,
                id: 'nameKana',
              },
              {
                label: '電話番号',
                content: e.data.key,
                id: 'phoneNumber',
              },
              {
                label: 'メールアドレス',
                content: e.data.mail,
                id: 'mail',
              },
              {
                label: '会社名',
                content: e.data.companyName,
                id: 'companyName',
              },
              {
                label: '部署名',
                content: e.data.departmentName,
                id: 'departmentName',
              },
              {
                label: '住所',
                content: e.data.address,
                id: 'address',
              },
              {
                label: 'メモ',
                content: e.data.memo,
                verticalAlign: 'top',
                paragraph: true,
                id: 'memo',
              },
            ];
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡先情報取得'));
        });
    },
    handleEditCallerInformation() {
      this.$router.push({
        path: '/contactlist/edit',
        query: {
          contactID: this.$route.query.contactID,
          wordFlag: this.$route.query.wordFlag,
          searchFormType: this.$route.query.searchFormType,
          companyID: this.selectedCompanyID,
        },
      }); // #2121
    },
    handleDeleteCallerInformation: async function (contactID) {
      await this.postRequest('/contactlist/delete', { contactID: contactID, companyID: this.selectedCompanyID })
        .then(e => {
          if (e.session) {
            this.routingAfterCloseModalFlag = true;
            this.showInfoModal(messageContent.notifyPhoneBookDeleted());
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡先削除'));
        });
    },
    handleCancel(e) {
      this.$router.push({
        path: '/contactlist',
        query: {
          wordFlag: this.$route.query.wordFlag,
          searchFormType: this.$route.query.searchFormType,
          companyID: this.selectedCompanyID,
        },
      }); // #2121
    },
    handleCallNumberClick() {
      this.$router.push({ path: '/home', query: { contactID: this.$route.query.contactID } });
    },
  },
};
</script>
